import { Component, OnInit } from '@angular/core';
import { StatsService } from '../../../../resources/stats/stats.service';
import * as moment from 'moment';
import 'moment/locale/pl';

@Component({
  selector:    'app-fleet-usage',
  templateUrl: './fleet-usage.component.html',
  styleUrls:   [ './fleet-usage.component.scss' ]
})
export class FleetUsageComponent implements OnInit {

  lineChartData: Array<any>;
  lineChartLabels: Array<any> = [];

  lineChartOptions: any = {
    responsive:          true,
    maintainAspectRatio: false,
    tooltips:            {
      backgroundColor: '#fff',
      titleFontColor:  '#333',
      bodyFontColor:   '#333',
      displayColors:   false,
      callbacks:       {
        title: () => '',
        label: (item, d) => {
          return moment(item.xLabel).format('DD.MM.YY') + ': ' + item.yLabel;
        }
      }
    },
    scales:              {
      yAxes: [ {
        type: 'linear'
        // ticks: {
        //   stepSize: 20
        // }
      } ],
      xAxes: [ {
        type:         'time',
        distribution: 'linear',
        time:         {
          displayFormats: {
            day:   'D.MM',
            month: 'D.MM'
          }
        }

      } ]
    }
  };
  lineChartColors: Array<any> = [
    { // grey
      backgroundColor:           'rgba(169,206,77,0.2)',
      borderColor:               'rgba(169,206,77,1)',
      pointBackgroundColor:      'rgba(148,159,177,1)',
      pointBorderColor:          '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor:     'rgba(148,159,177,0.8)'
    },
    { // grey
      backgroundColor:           'rgba(250,56,57,0.2)',
      borderColor:               'rgba(250,56,57,1)',
      pointBackgroundColor:      'rgba(148,159,177,1)',
      pointBorderColor:          '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor:     'rgba(148,159,177,0.8)'
    }
  ];
  lineChartType = 'line';

  constructor(private stats: StatsService) {
  }

  ngOnInit() {
    this.stats.fleetUsage().subscribe((data) => {

      this.lineChartData = data.data.map((d, index) => {
        return {
          pointBackgroundColor: 'rgba(169,206,77,1)',
          pointBorderColor:     'rgba(169,206,77,0)',
          pointBorderWidth:     0,
          pointRadius:          0,
          pointHitRadius:       8,
          data:                 d,
          label:                data.labels[ index ]
        };
      });
    });
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/stats/fleet-usage/fleet-usage.component.ts